<template>
  <div id="tablePhoto">
    <b-row
        class="col-8"
        style="border: 1px solid #ECEFF1; border-radius: 8px;">
        <b-col 
            cols="12"
            class="mt-4">
            <h4 
                class="col-12 text-formatting-v2"
                style="font-size: 24px;">
                <strong>
                    Progreso de perfiles actualizados
                </strong>
            </h4>
        </b-col>
        <b-col 
            cols="12" 
            class="d-flex align-items-center mb-4">
                <div class="col-9">
                    <b-progress
                        :value="progressBarPhotos.employees_with_photo" 
                        :max="progressBarPhotos.total">
                    </b-progress>
                </div>
                <div>
                    <p class="col text-formatting-v2 ">
                        <strong>
                            {{progressBarPhotos.percentage}}% cargado
                        </strong> 
                    </p>
                </div>
        </b-col>
    </b-row>

    <template  v-if="loading3">
        <loader-version2 />
    </template>

    <template v-else>
        <b-row 
            class="pt-5" 
            style="margin-left: -30px;">

            <b-col cols="12"  class="mb-3">
                <button v-b-toggle.filtroPhotos class="button-v2 outline-primary border-round d-flex float-left">
                    <div class="m-1 d-flex align-items-center">
                        <p class="m-0 pr-2">Filtro</p>
                        <img class="centerImg1 arrow" src="@/assets/images/icons/ht_icon_stack.svg" width="15px">
                    </div>
                </button>
            </b-col>
            <!-- Carta de busqueda -->
            <b-col cols="12" class="mb-3">
                <b-collapse 
                    id="filtroPhotos" 
                    class="col-12 mt-4 py-5 filter card-v2 with-border">
                    <b-container>
                        <b-row>
                            <b-col class="8">
                                <b-col>
                                    <h3 class="text-formatting-v2" style="font-weight: 700; font-size: 18px; line-height: 24px;">
                                        <strong>Buscar</strong> 
                                    </h3>
                                    <hr>
                                </b-col>
                                <b-col>
                                    <div 
                                        class="left-and-right-inner-addon" 
                                        style="top: -10px;">
                                        <img
                                            class="right"
                                            :src="require('@/assets/images/icons/ht_icon_store_3_line.svg')">
                                        <input 
                                            v-model="filter" 
                                            @keydown="startTipyng()" 
                                            @keyup="finishTipyng()" 
                                            type="text" 
                                            class="col-12 my-3 input-v2 input-v2-by-search with-image-left" 
                                            placeholder="Busqueda por nombre o ID">
                                    </div>                                   
                                </b-col>
                                <b-col>
                                    <button 
                                        class="button-v2 danger border-round mt-2 mb-4" 
                                        @click.prevent="filter = '',  filterSelected = null, filterStatus()">
                                        <strong class="text-formatting-v2">
                                            Quitar todos los filtros
                                        </strong> 
                                    </button>
                                </b-col>
                            </b-col>
                            <b-col class="4">
                                <b-col>
                                    <h3 class="text-formatting-v2" style="font-weight: 700; font-size: 18px; line-height: 24px;">
                                        <strong>Estado</strong> 
                                    </h3>
                                    <hr>
                                </b-col>
                                <b-col class="ml-4 mt-4">
                                    <input 
                                        v-model="filterSelected" 
                                        type="radio" 
                                        v-on:change="filterStatus()" 
                                        id="approved" 
                                        name="approved" 
                                        value="approved"
                                        class="mr-2">
                                    <label for="approved"> 
                                        <span 
                                            class="status mt-4 p-1 text-formatting-v2" 
                                            style="background-color:#EDF9F0; color: #00761A; border-radius: 8px;">
                                            <img 
                                                class="centerImg1 mr-2"  
                                                src="@/assets/images/icons/check.svg" 
                                                width="20px">Cargado
                                        </span>    
                                    </label>
                                </b-col>
                                <b-col class="ml-4 mt-2">
                                    <input 
                                        v-model="filterSelected" 
                                        type="radio" 
                                        v-on:change="filterStatus()" 
                                        id="pending" 
                                        name="pending" 
                                        value="pending"
                                        class="mr-2 ">
                                    <label for="pending"> 
                                        <span 
                                            class="status mt-4 p-1 text-formatting-v2" 
                                            style="background-color:#FFF4EC; color: #E66401; border-radius: 8px;">
                                            <img 
                                                class="centerImg1 mr-2"
                                                src="@/assets/images/icons/orange-clock.svg" 
                                                width="20px">Pendiente
                                        </span>   
                                    </label>
                                </b-col>
                                <b-col class="ml-4 mt-2">
                                    <input 
                                        v-model="filterSelected" 
                                        type="radio" 
                                        v-on:change="filterStatus()" 
                                        id="all" 
                                        name="all"
                                        value=""
                                        class="mr-2"> 
                                        <span class="status mt-4 p-1 text-formatting-v2">
                                            Todos
                                        </span>
                                </b-col>
                            </b-col> 
                        </b-row>
                    </b-container>
                </b-collapse>
            </b-col>
            <!-- end -->
            <!-- Tabla -->
            <b-col 
                cols="12" 
                class="table-responsive datatable no-box-shadow table-with-borders-and-box-shadow">
                <b-table 
                    id="b-table"
                    :fields="fields"
                    :items="dataTable.rows"
                    head-variant="light">
                        <template #cell(name)="row">
                            <td class="pl-2">
                                {{row.item.name.name}}<br>
                                <span class="status p-1 d-flex">
                                    <img 
                                        class="centerImg1"
                                        :src="require('@/assets/images/icons/ht_icon_user.svg')" 
                                        width="20px">
                                    <strong>
                                        {{ row.item.name.cc }}
                                    </strong> 
                                </span>
                            </td>
                        </template>
                        <template #cell(state)="row" >
                                <span 
                                    class="status" 
                                    :style="`background-color: ${row.item.state.color}; color: ${row.item.state.text  === 'Cargada' ?  '#00761A':'#E66401'}; border-radius: 8px;`">
                                    <img 
                                        class="centerImg1 mr-1"
                                        :src="require('@/assets/images/icons/' + row.item.state.icon)" 
                                        width="20px">
                                    {{row.item.state.text}}
                                </span>
                        </template>
                        <template #cell(view)="row">
                            <div v-if="row.item.state.img">
                                    <span 
                                        :id="row.item.name.cc" 
                                        style="font-size:10px;" 
                                        class="pointer">
                                        <img 
                                            class="centerImg1 mr-1" 
                                            :src="require('@/assets/images/icons/eye-line.png')" 
                                            width="20px"/> 
                                    </span>
                                    <b-popover
                                        :target="row.item.name.cc"
                                        triggers="hover focus">
                                        <img 
                                            :src="serverPath + '/' + row.item.state.link" 
                                            width="80px" 
                                            height="80px">
                                    </b-popover>
                            </div>
                            <p v-else>--</p>
                        </template>
                </b-table>
                <b-col 
                    cols="12" 
                    class="pagination-v2 my-5 d-flex justify-content-center">
                    <Pagination 
                        :data="tablePhoto" 
                        :limit="10" 
                        @pagination-change-page="loadRowsPhotoPag" />
                </b-col>
            </b-col>
            <!-- end -->
        </b-row>
    </template>
  </div>
</template>

<script>
import { mapState,mapActions } from "vuex";
import Pagination from "laravel-vue-pagination";
import serverConfig from "../../../services/config";
export default {
    components: {
        Pagination
     },
    data() {
        return {
            serverPath: serverConfig.permisosURL,
            dataTable:{
                rows: [],
            },
            runtime:'',
            filter:'',
            filterSelected:[],
        }
    },
    computed: {
        ...mapState("modOhAnalyst", [
        "loading",
        "loading3",
        "tablePhoto",
        "progressBarPhotos"
      ]),
      fields () {
        return [
            {
                label: 'Nombre / C.C',
                key: 'name',
                sortable: true
            },
            {
                label: 'Cargo',
                key: 'position',
                sortable: true
            },
            {
                label: 'Área',
                key: 'area',
                sortable: true
            },
            {
                label: 'Fotografía',
                key: 'state',
                sortable: true
            },
            {
                label: '',
                key: 'view',
                sortable: false
            },
        ]
      }
    },
    beforeMount(){    
        let data = {
            page: ''
        }   
        this.loadRowsPhoto(data)
        this.actGetProgressBarPhotos()
    },
    methods: {
        ...mapActions("modOhAnalyst", [
        'actCheckEmployeesWithPhoto',
        'actGetProgressBarPhotos'
        ]),
        startTipyng(){
            clearTimeout(this.runTime)
        },
        finishTipyng(){
            let data = {
                search: this.filter,
                status: this.filterSelected
            } 
            this.runTime = setTimeout(() => {
                      this.loadRowsPhoto(data)
            }, 1500);   
        },
        filterStatus(){
            let data = {
                search: this.filter,
                status: this.filterSelected
            } 
            this.loadRowsPhoto(data)
        },
        async loadRowsPhoto(data){
            this.photo = true
            await this.actCheckEmployeesWithPhoto(data).then(() =>{
                this.dataTable.rows = []
                
                this.tablePhoto.data.forEach(x => {
                    let status = {}
                    if (x.image == 'storage/docs_vp2/health_tracker/user-default.svg'){
                            status = {
                                color:'#FFF4EC',
                                icon: 'orange-clock.svg',
                                text: 'Pendiente',
                                img:false
                            }
                    }else{
                        status = {
                            color:'#EDF9F0',
                            icon: 'check.svg',
                            text: 'Cargada',
                            img: true,
                            link: x.image
                        }
                    }                     
                    let employee = {
                        name:x.name,
                        cc: x.cc
                    }
                    this.dataTable.rows.push({
                        name: employee,
                        position: x.charge,
                        area: x.area,
                        state: status,
                        view: (status.img ? status.link:'')
                    })
                })
            })
            
            this.forgetTableStyleById()
        },
        loadRowsPhotoPag(page = 1){
            let data = {
                search: this.filter,
                page:page,
                status: this.filterSelected
            }
            this.loadRowsPhoto(data)
        },
    }
}
</script>

<style lang="scss">
#tablePhoto{
    .filter{
        border: solid rgb(207, 207, 207) 1px;
        border-radius: 12px;
        background-repeat: no-repeat;
        background: #FFFFFF;
        background-position: right bottom;
        background-size: 15%;
        h3{
            font-weight: 600;
            color:var(--main-primary-color);
        }
    }
    .progress {
        height: 2rem;
        border: 1px solid #ECEFF1;
        border-radius: 8px;
    }
    .progress-bar {
        background: linear-gradient(270deg, #0C9E42 -0.16%, #7DFFA9 100%);
    }
    .datatable table thead tr th {
        width: 0;
    }

    .left-and-right-inner-addon {
        position: relative;

        img.right {
            position: absolute;
            right: 0px;
            padding: 30px 6px;
            pointer-events: none;
        }
    }
}
</style>